export const firebaseConfig = {
    // apiKey: "AIzaSyC3HJR3Lj2hMtevQOYV8wNWGv-7EsB-8V8",
    // authDomain: "ecer1-0.firebaseapp.com",
    // databaseURL: "https://ecer1-0.firebaseio.com",
    // projectId: "ecer1-0",
    // storageBucket: "ecer1-0.appspot.com",
    // messagingSenderId: "490785262349",
    // appId: "1:490785262349:web:4f681a6cfcb6d53af63e44"

    apiKey: "AIzaSyAkWEAQ5eE2Mau6Avh2ZmMM8fFvnlS39KE",             
    authDomain: "ecer1-0.firebaseapp.com",
    databaseURL: "https://ecer1-0.firebaseio.com",
    projectId: "ecer1-0",
    storageBucket: "ecer1-0.appspot.com",
    messagingSenderId: "490785262349",
    appId: "1:490785262349:web:4f681a6cfcb6d53af63e44"

    // apiKey: "AIzaSyC-RNQ0dUw3BHo8Sfnjkhh_fe-gDEuMvpM",
    // authDomain: "ecer1-0-301422.firebaseapp.com",
    // projectId: "ecer1-0-301422",
    // storageBucket: "ecer1-0-301422.appspot.com",
    // messagingSenderId: "281088114531",
    // appId: "1:281088114531:web:c852f1fa46879768cf9d56"
  };
